import React, { useState } from "react";
import "./chatmessage.scss";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";

const dates = [
  { day: "Fri", date: "31" },
  { day: "Sat", date: "01" },
  { day: "Sun", date: "02" },
  { day: "Mon", date: "03" },
  { day: "Tue", date: "04" },
  { day: "Fri", date: "31" },
  { day: "Sat", date: "01" },
  { day: "Sun", date: "02" },
  { day: "Mon", date: "03" },
  { day: "Tue", date: "04" }
];

const slots = [
  "9.00-10:00","10:00-10:30","10:30-11:00","11:00-11:30","11:30-12:00",
  "12:00-12:30","12:30-01:00","01:00-01:30","01:30-02:00","02:00-02:30",
  "02:30-03:00","03:00-03:30","03:30-04:00","04:00-04:30","04:30-05:00"
];

export default function Chat() {
  const [activeDate, setActiveDate] = useState(2);
  const [selectedSlot, setSelectedSlot] = useState(0);

  return (
    <div className="container py-4">
      <div className=""><div>
  <h4 className='mt-3 font-bold mb-2'><Link to="/homepage"><svg width="35" height="35" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="43" height="43" rx="4.5" stroke="#161616" stroke-opacity="0.3" />
            <path d="M25.8865 31.6615L16.165 21.9999L25.8865 12.3384L27.1748 13.6267L18.8016 21.9999L27.1748 30.3732L25.8865 31.6615Z" fill="#161616" />
          </svg></Link>&nbsp;
          Chat</h4></div>
          Set your time according to UAE timezone
        
          </div>
      {/* timezone alert */}
      <div className="chat-card mt-3">

        <div className="row g-0 h-100">

          {/* LEFT SIDEBAR */}
          <div className="col-lg-4 border-end chat-list">

            {/* User */}
            <div className="chat-user active">
              <img src="https://i.pravatar.cc/50?img=1" alt="" />

              <div className="flex-grow-1">
                <div className="name">Amar Khaushik</div>
                <div className="msg">Hello, I trust this message finds you well.</div>
              </div>

              <span className="badge-count">3</span>
            </div>


            <div className="chat-user">
              <img src="https://i.pravatar.cc/50?img=5" alt="" />

              <div className="flex-grow-1">
                <div className="name">Shoumika Singh</div>
                <div className="msg">Your recent decisions have certainly caught...</div>
              </div>

              <span className="badge-count">2</span>
            </div>


            <div className="chat-user">
              <img src="https://i.pravatar.cc/50?img=12" alt="" />

              <div className="flex-grow-1">
                <div className="name">Karan Malhotra</div>
                <div className="msg">Lorem Ipsum is simply dummy text of printing</div>
              </div>
            </div>

          </div>



          {/* RIGHT PANEL */}
          <div className="col-lg-8 d-flex flex-column">

            {/* Header */}
            <div className="chat-header d-flex justify-content-between align-items-center">

              <div className="d-flex align-items-center gap-2">
                <img src="https://i.pravatar.cc/45?img=1" alt="" />
                <strong>Amar Khaushik</strong>
              </div>

              <button className="btn btn-outline-secondary btn-sm align-items-center gap-1 d-flex text-dark">
            <div>    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.0014 17.9173C8.90638 17.9173 7.87714 17.7095 6.91367 17.294C5.9502 16.8784 5.11214 16.3145 4.3995 15.6021C3.68686 14.8897 3.12263 14.052 2.70679 13.089C2.2911 12.1259 2.08325 11.097 2.08325 10.0021C2.08325 8.90711 2.29103 7.87787 2.70659 6.9144C3.12214 5.95093 3.6861 5.11287 4.39846 4.40023C5.11082 3.6876 5.94853 3.12336 6.91159 2.70753C7.87464 2.29183 8.9036 2.08398 9.99846 2.08398C11.0935 2.08398 12.1227 2.29176 13.0862 2.70732C14.0496 3.12287 14.8877 3.68683 15.6003 4.39919C16.313 5.11155 16.8772 5.94926 17.293 6.91232C17.7087 7.87537 17.9166 8.90433 17.9166 9.99919C17.9166 11.0942 17.7088 12.1234 17.2933 13.0869C16.8777 14.0504 16.3137 14.8884 15.6014 15.6011C14.889 16.3137 14.0513 16.8779 13.0883 17.2938C12.1252 17.7095 11.0962 17.9173 10.0014 17.9173ZM9.99992 16.6673C10.7817 16.6673 11.5346 16.5351 12.2587 16.2707C12.9826 16.0062 13.6442 15.6235 14.2435 15.1225L4.87804 5.75711C4.38235 6.35641 4.00096 7.01801 3.73388 7.7419C3.46679 8.46593 3.33325 9.21884 3.33325 10.0007C3.33325 11.8618 3.97909 13.4382 5.27075 14.7298C6.56242 16.0215 8.13881 16.6673 9.99992 16.6673ZM15.1218 14.2442C15.6228 13.6449 16.0055 12.9833 16.2699 12.2594C16.5344 11.5354 16.6666 10.7825 16.6666 10.0007C16.6666 8.13954 16.0208 6.56315 14.7291 5.27148C13.4374 3.97982 11.861 3.33398 9.99992 3.33398C9.21617 3.33398 8.46145 3.46489 7.73575 3.72669C7.0102 3.98836 6.3504 4.37239 5.75638 4.87878L15.1218 14.2442Z" fill="#222222"/>
</svg></div>
<div>
 Block</div>
              </button>

            </div>


            {/* Messages */}
            <div className="chat-body flex-grow-1">
 <div className="p-0">

      {/* Incoming Message */}
      <div className="d-flex mb-4">
        <div className="chat-bubble chat-left">
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum is simply dummy text of the printing and
          typesetting industry.

          <div className="chat-time">10:30 AM</div>
        </div>
      </div>


      {/* Outgoing Message */}
      <div className="d-flex justify-content-end mb-4">
        <div className="chat-bubble chat-right">
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum is simply dummy text of the printing and
          typesetting industry.

          <div className="chat-time text-white-50">10:30 AM</div>
        </div>
      </div>

    </div>

            </div>


            {/* Input */}
            <div className="chat-input">

              <input
                className="form-control"
                placeholder="Type something..."
              />

              <button className="btn btn-light"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.5 4C10.7 4 10 4.7 10 5.5C10 6.3 10.7 7 11.5 7C12.3 7 13 6.3 13 5.5C13 4.7 12.3 4 11.5 4ZM17 0H3C1.3 0 0 1.3 0 3V17C0 18.7 1.3 20 3 20H17C18.7 20 20 18.7 20 17V3C20 1.3 18.7 0 17 0ZM18 11.9L16.1 10C14.9 8.9 13 8.9 11.9 10L11 10.9L8.1 8C6.9 6.9 5 6.9 3.9 8L2 9.9V3C2 2.4 2.4 2 3 2H17C17.6 2 18 2.4 18 3V11.9Z" fill="#BABABA"/>
</svg>
</button>

              <button className="btn send-btn">➤</button>

            </div>

          </div>

        </div>
      </div>

    </div>
  );
}
